var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"d-block w-100 he-100 tw-rounded-lg mb-3 tw-object-cover",style:('background: url(' +
    _vm.uriResources +
    '/' +
    _vm.product.img +
    ') no-repeat; background-size: cover;'),attrs:{"to":'/e-commerce/product/' + _vm.product.id}},[_c('div',{staticClass:"position-absolute shaw-h-sm wi-300 he-100 tw-rounded-lg"},[_c('p',{staticClass:"text-white text-uppercase tw-text-sm wi-200 mt-3 ml-3 line-height-1"},[_vm._v(" "+_vm._s(_vm.product.name)+" ")]),_c('p',{staticClass:"text-white font-weight-bold tw-text-sm ml-3"},[_vm._v("¡Regalo!*")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }